import React, { useEffect, useState } from "react";
import {
  ArrowLeftIcon,
  UserCircleCheckIcon,
  PencilSimpleLineIcon
} from "@phosphor-icons/react";
import Button from "components/Buttons";
import Icon from "components/Icon/Icon";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { EditProfileInfo } from "./EditProfileInfo";
import { ProfileOverview } from "./ProfileOverview";

import { useCreatorUsersSlice } from "pages/CreatorUsers/slice/index";
import {
  getCreatorUserDetails,
  getUpdateCreatorInfo
} from "pages/CreatorUsers/slice/selectors";
import { useDispatch, useSelector } from "react-redux";
import { CreatorUserProfileInfoContainer } from "./styled";
import LoadingSpinner from "components/PageLoader/Spinner";

const UserProfileInfo = () => {
  const { user: creatorUser } = useSelector(getCreatorUserDetails);
  const { loading, success } = useSelector(getUpdateCreatorInfo);

  const { actions: creatorUsersActions } = useCreatorUsersSlice();
  const dispatch = useDispatch();

  const { userId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const viewType = searchParams.get("mode") || "view";

  const [editInformation, setEditInformation] = useState({
    skip_criteria_check_for_social: false
  });

  useEffect(() => {
    dispatch(
      creatorUsersActions.fetchCreatorUserByIdRequest({
        userId: userId
      })
    );
  }, [userId]);

  const updateCreatorUserInfo = () => {
    dispatch(
      creatorUsersActions.updateCreatorUserRequest({
        userId: creatorUser.id,
        updateData: {
          skip_criteria_check_for_social:
            editInformation.skip_criteria_check_for_social ? 1 : 0
        }
      })
    );
  };

  useEffect(() => {
    if (success) {
      const params = new URLSearchParams(searchParams);

      params.set("mode", "view");

      navigate(
        {
          pathname: `/creator-users/${creatorUser.id}`,
          search: params.toString()
        },
        { replace: true }
      );
    }
  }, [success]);

  return (
    <CreatorUserProfileInfoContainer>
      <div className="user-info-header">
        <div className="header-left-section">
          <figure
            onClick={() => {
              const params = new URLSearchParams(searchParams);

              if (viewType === "edit") {
                params.set("mode", "view");

                navigate({
                  pathname: `/creator-users/${creatorUser.id}`,
                  search: params.toString()
                });
              } else {
                navigate({
                  pathname: `/creator-users`,
                  search: params.toString()
                });
              }
            }}
          >
            <Icon component={ArrowLeftIcon} />
          </figure>
          <h2>
            {viewType === "edit"
              ? `Edit ${creatorUser?.first_name ? creatorUser?.first_name : "Details"}`
              : `${creatorUser?.first_name ? creatorUser?.first_name : "Profile Details"}`}
          </h2>
          <div className="user-role-badge">
            <Icon component={UserCircleCheckIcon} color="#8664C5" />
            <span>Creator User</span>
          </div>
        </div>

        {viewType === "view" ? (
          <Button
            size="M"
            variant="primary"
            leftIcon={<Icon component={PencilSimpleLineIcon} color="#FFFFFF" />}
            onClick={() => {
              const params = new URLSearchParams(searchParams);
              params.set("mode", "edit");

              navigate({
                pathname: `/creator-users/${creatorUser.id}`,
                search: params.toString()
              });
            }}
          >
            Edit Details
          </Button>
        ) : (
          ""
        )}
      </div>

      <div
        className={`profile-information-container ${viewType === "edit" ? "edit-mode" : ""}`}
      >
        {viewType === "view" ? (
          <ProfileOverview creatorUserDetails={creatorUser} />
        ) : (
          <EditProfileInfo
            creatorUserDetails={creatorUser}
            setEditInformation={setEditInformation}
            editInformation={editInformation}
          />
        )}
      </div>

      {viewType === "edit" && (
        <div className="profile-edit-footer">
          <Button
            variant="secondary"
            onClick={() => {
              const params = new URLSearchParams(searchParams);
              params.set("mode", "view");

              navigate({
                pathname: `/creator-users/${creatorUser.id}`,
                search: params.toString()
              });
            }}
          >
            Cancel
          </Button>
          <Button
            size="M"
            variant="primary"
            onClick={updateCreatorUserInfo}
            disabled={loading}
          >
            {loading ? (
              <LoadingSpinner color="#FFFFFF" size={12} />
            ) : (
              "Save Changes"
            )}
          </Button>
        </div>
      )}
    </CreatorUserProfileInfoContainer>
  );
};

export default UserProfileInfo;
